import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAutocomplete,{attrs:{"hide-details":"","hint":`${_vm.localValue}`,"label":"Select Athlete Name","items":_vm.getAthletes,"item-value":"athleteId","item-text":_vm.athleteLongName,"dense":"","rules":_vm.requiredRule,"outlined":"","sort":"","clearable":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }